// extracted by mini-css-extract-plugin
export default {"ComponentName":"ComponentName_ComponentName__Aj6aU","ComponentName__Text":"ComponentName_ComponentName__Text__w6aHb"};